import { render, staticRenderFns } from "./MemberTypeCard.vue?vue&type=template&id=d928905e&"
import script from "./MemberTypeCard.vue?vue&type=script&lang=js&"
export * from "./MemberTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./MemberTypeCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports